import React, { Fragment } from 'react'

import PropTypes from 'prop-types'
import './UserTypeSelection.css'
import './steps2.css'

const Steps2 = (props) => {
  return (
    <div className="steps2-container1 thq-section-padding">
      <div className="steps2-max-width thq-section-max-width">
        <div className="steps2-container2 thq-grid-2">
          <div className="steps2-section-header">
            <h2 className="thq-heading-2">
              Discover the Power of Our Platform
            </h2>
            <p className="thq-body-large mt-4 justify">
            This app is designed especially for you, the backbone of every construction project. Here you can easily find work opportunities, keep track of your payments, connect with contractors directly. Let's make your work life simpler and more rewarding, right here on your phone.
            </p>

            <p className="thq-body-large mt-4 justify">
            Stop waiting and start taking control of your work life today. Explore the features of our platform and discover how it can empower you to connect with more opportunities, manage your earnings effectively, and build a stronger future. It's time to experience a better way to work – your power is now in your hands.
            </p>
            
          </div>
          <div className="steps2-container3">
            <div className="steps2-container4 thq-card">
              <h2 className="thq-heading-2">
                {props.step1Title ?? (
                  <Fragment>
                    <span className="steps2-text28">Sign Up</span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text14 thq-body-small">
                {props.step1Description ?? (
                  <Fragment>
                    <span className="steps2-text29">
                      Create an account on our job portal to access all features
                      and functionalities.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text15 thq-heading-3">01</label>
            </div>
            <div className="steps2-container5 thq-card">
              <h2 className="thq-heading-2">
                {props.step2Title ?? (
                  <Fragment>
                    <span className="steps2-text30">Browse Jobs</span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text17 thq-body-small">
                {props.step2Description ?? (
                  <Fragment>
                    <span className="steps2-text25">
                      Browse through a wide range of job listings from various locations.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text18 thq-heading-3">02</label>
            </div>
            <div className="steps2-container6 thq-card">
              <h2 className="thq-heading-2">
                {props.step3Title ?? (
                  <Fragment>
                    <span className="steps2-text26">Dashboard</span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text20 thq-body-small">
                {props.step3Description ?? (
                  <Fragment>
                    <span className="steps2-text31">
                      Employers can easily post job openings to attract
                      qualified candidates.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text21 thq-heading-3">03</label>
            </div>
            {/* <div className="steps2-container7 thq-card">
              <h2 className="thq-heading-2">
                {props.step4Title ?? (
                  <Fragment>
                    <span className="steps2-text27">Dashboard</span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text23 thq-body-small">
                {props.step4Description ?? (
                  <Fragment>
                    <span className="steps2-text32">
                      Manage job postings, applications, and track the
                      recruitment process efficiently.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text24 thq-heading-3">03</label>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

Steps2.defaultProps = {
  step2Description: undefined,
  step3Title: undefined,
  step4Title: undefined,
  step1Title: undefined,
  step1Description: undefined,
  step2Title: undefined,
  step3Description: undefined,
  step4Description: undefined,
}

Steps2.propTypes = {
  step2Description: PropTypes.element,
  step3Title: PropTypes.element,
  step4Title: PropTypes.element,
  step1Title: PropTypes.element,
  step1Description: PropTypes.element,
  step2Title: PropTypes.element,
  step3Description: PropTypes.element,
  step4Description: PropTypes.element,
}

export default Steps2
